// Modules
import React, { Component } from 'react';

// Styles
import './Week.scss'

// Interfaces
import {Tip} from 'Interfaces/TipInterface';

// Components
import Day from '../Day';
import ToolTip from "../../ToolTip";

interface IProps {
    weekDays:Date[];
    enabledDates: (string | Date)[];
    onDayClick(date:Date):void;
    activeDate: Date | null;
    dayTooltips?: {[index: string]: Tip[]};
    isDateOutsideWindow(date: Date): boolean;
    hasLoadError: boolean;
}

interface IState {

}


class Week extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
    }

    getDateStamp(date: Date) {
        return (`${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`);
    }

    getEmptyStamp() {
        return (`${this.props.weekDays[0].getFullYear()}-${this.props.weekDays[0].getMonth()}`);
    }

    getArr(num: number){

        let arr = []
        for(let i = 0; i< num; i++){
            arr.push(1)
        }
        return arr
    }

    render() {
        let firstDay = this.props.weekDays[0].getDay();
        let lastDay = this.props.weekDays[this.props.weekDays.length - 1].getDay();
        let blankStart = firstDay;
        let blankEnd = 6 - lastDay;

        return (
            <tr className="week">
                {this.getArr(blankStart).map((_, index:number) =>
                    <td key={"empty-start-" + this.getEmptyStamp() + '-' + index}></td>
                )}

                {this.props.weekDays.map((day:Date) => {
                  	const dayEnabled = this.props.enabledDates.some((date) => {
                        return date.valueOf() === day.valueOf();
                    });
				            const dayActive = this.props.activeDate !== null &&
                    	this.props.activeDate.valueOf() === day.valueOf();

                    const dayTooltip = this.props.dayTooltips && this.props.dayTooltips[day.valueOf()] ?
                    	this.props.dayTooltips[day.valueOf()] : [];

                    const dayOutsideWindow = (this.props.hasLoadError) || this.props.isDateOutsideWindow(day);

                    return (
                      <td
                          key={"day-" + this.getDateStamp(day)}
                          className="week-day"
  						  aria-selected={dayActive}
                      >
	                      <Day
                            day={day}
                            dayEnabled={dayEnabled && !dayOutsideWindow}
                            onClick={this.props.onDayClick}
                            activeDate={this.props.activeDate}
                            tooltip={dayTooltip}
                            dayOutsideWindow={dayOutsideWindow}
	                      />

                      </td>
                    );
                })}
                {this.getArr(blankEnd).map((_, index:number) =>
                    <td key={"empty-end-" + this.getEmptyStamp() + '-' + index}></td>
                )}
            </tr>
        );
    }
}

export default Week;
